import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '@dashboard/services/request';
import { pageKey } from '@dashboard/lib/queryKeys';
import usePage from '@dashboard/hooks/usePage';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import Dialog from '@dashboard/components/Dialog';
import { Form } from '@dashboard/components/Formik';
import { useTicketGroupEdit } from '../TicketGroupEditContext';

const AddTicketGroupDialog = () => {
  const { sellerId, token } = useAuth();
  const { page } = usePage();
  const queryClient = useQueryClient();

  const {
    isAddingTicketGroup,
    setIsAddingTicketGroup,
    setIsEditingTicketGroup,
    setIsAddingTicketType,
  } = useTicketGroupEdit();

  const addTicketGroupMutation = useMutation({
    mutationFn: values =>
      fetcher(`/sellers/${sellerId}/ticket-groups`, token, {
        method: 'POST',
        body: JSON.stringify({
          ...values,
          pageId: page._id,
        }),
      }),
    onSuccess: async data => {
      setIsAddingTicketGroup(false);

      await queryClient.invalidateQueries({ queryKey: pageKey(page._id) });

      setIsEditingTicketGroup(true, data._id);
      setIsAddingTicketType(true);
    },
  });

  function closeDialog() {
    setIsAddingTicketGroup(false);
  }

  return (
    <Dialog
      title="Add ticket group"
      cancelButton={null}
      confirmButton={null}
      open={isAddingTicketGroup}
      onCancel={closeDialog}
      size="lg"
    >
      <Form
        initialValues={{
          name: '',
          capacity: null,
        }}
        fields={[
          {
            name: 'name',
            label: 'Group name',
            type: 'text',
            required: true,
            autoFocus: true,
            autoComplete: 'off',
          },
          {
            name: 'capacity',
            label: 'Group capacity',
            placeholder: 'Capacity',
            type: 'number',
          },
        ]}
        onSubmit={async values => {
          try {
            const data = await addTicketGroupMutation.mutateAsync(values);

            closeDialog();

            return {
              data,
            };
          } catch (error) {
            return {
              error,
            };
          }
        }}
        submitButton={{
          label: 'Continue',
          size: 'full',
          arrowRight: true,
        }}
        showState={false}
      />
    </Dialog>
  );
};

export default AddTicketGroupDialog;
